define(["mw-log/impl/Modes"], function (Modes) {

    const utils = {};

    utils.objectValues = function (object){
        let arr = [];
        for(let key in object) {
            arr.push(object[key]);
        }
        return arr;
    };

    utils.makeReadOnlyProperty = function(object, key, value){
        Object.defineProperty(object, key, {
            value: value,
            writable: false
        });
    };

    utils.execCallbacks = function(callbacks, message){
        const cbList = utils.objectValues(callbacks);
        for(let i in cbList){
            cbList[i](message);
        }
    };

    utils.currentTimeString = function(){
        const now = new Date();
        return now.toLocaleTimeString('en-US', { hour12: false,
            hour: "numeric",
            minute: "numeric",
            second: "numeric"}) + "." + (now.getTime() % 1000);
    };

    utils.printToConsole = function(method, args, mode){
        // check for production mode
        // in production mode, still show errors
        if( mode !== Modes.PRODUCTION || method === "error" ){
            console[method].apply(console, args);
        }
    };
    return utils;
});